// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"66c6463e","498":"809479ac","943":"3ad0d681"}[chunkId] + ".chunk.css";
};